export default "__VITE_ASSET__D7NYrWFY__"